import { Injectable, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, concatMap, timer, of, takeUntil, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class SnackbarQueueService implements OnDestroy {
  private queue = new BehaviorSubject<{ message: string, panelClass: string } | null>(null);
  private destroyed$ = new Subject<void>();

  constructor(private snackBar: MatSnackBar) {
    this.queue.pipe(
      takeUntil(this.destroyed$),
      concatMap(notification => {
        if (!notification) {
          return of();
        }
        this.snackBar.open(notification.message, '', {
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          panelClass: notification.panelClass,
          duration: 5000,
        });
        return timer(5000);
      })
    ).subscribe();
  }

  /**
   * @param message
   * @param string
   */
  addNotification(message: string, panelClass: string) {
    this.queue.next({ message, panelClass });
  }

  /**
   * Ng lifecycle
   * @return void
   */
  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
